import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function queryS3DownloadUrl(
  timeslotId: string,
): Promise<string | null> {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/timeslot_orchid_pro/session-audio-download-url/${timeslotId}`,
  );
  if (!res.ok) {
    if (res.status === 403) return null;
    throw new Error(
      `failed to get userInfo: ${getErrorDetail(await res.text())}`,
    );
  }

  return (await res.json()).signed_url;
}
